import { inject } from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { Language } from '@shared/constants/language';
import { LocalStorageKeys } from '@shared/constants/local-storage-keys';
import { Observable, of, switchMap } from 'rxjs';

export const translationsGuard = (): Observable<boolean> | boolean => {
  const translation = inject(TranslationService);

  return of(
    (localStorage.getItem(LocalStorageKeys.LastSelectedLanguage) || Language.Norwegian) as Language
  ).pipe(switchMap((lang) => translation.setTranslation(lang)));
};
